var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCmeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1715 20.1424H13.0216C12.2813 20.1424 11.6763 19.5334 11.6763 18.7893V4.84525C11.6763 4.10107 12.2813 3.49207 13.0216 3.49207H15.1715C15.9104 3.49207 16.5168 4.10107 16.5168 4.84525V18.7893C16.5168 19.5334 15.9104 20.1424 15.1715 20.1424Z",
    stroke: "#506C8E",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48786 20.1424H3.33799C2.59905 20.1424 1.99268 19.5334 1.99268 18.7892V6.68143C1.99268 5.93725 2.59905 5.32825 3.33799 5.32825H5.48786C6.22811 5.32825 6.83318 5.93725 6.83318 6.68143V18.7892C6.83318 19.5334 6.22811 20.1424 5.48786 20.1424Z",
    stroke: "#506C8E",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0123 20.1425H17.8624C17.1235 20.1425 16.5171 19.5335 16.5171 18.7893V7.90473C16.5171 7.16054 17.1235 6.55286 17.8624 6.55286H20.0123C20.7525 6.55286 21.3576 7.16054 21.3576 7.90473V18.7893C21.3576 19.5335 20.7525 20.1425 20.0123 20.1425Z",
    stroke: "#506C8E",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5005 17.1562H21.0824",
    stroke: "#506C8E",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5005 14.1562H21.0824",
    stroke: "#506C8E",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3292 20.1424H8.18061C7.44036 20.1424 6.83398 19.5334 6.83398 18.7893V9.74088C6.83398 8.9967 7.44036 8.3877 8.18061 8.3877H10.3292C11.0694 8.3877 11.6758 8.9967 11.6758 9.74088V18.7893C11.6758 19.5334 11.0694 20.1424 10.3292 20.1424Z",
    stroke: "#506C8E",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96436 17.0707H11.545",
    stroke: "#506C8E",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmeIcon);
export default __webpack_public_path__ + "static/media/CMEIcon.04edd82c68d07c34d1c5ecc99d6408ea.svg";
export { ForwardRef as ReactComponent };